import React, { Suspense } from 'react'; 
import { useSnackbar } from "notistack";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
    createBrowserRouter,
    RouterProvider,
} from 'react-router-dom';

import { Authentication } from '../../Models/Authentication/Authentication';

import LocalStorageHelper from '../../Utilities/Helpers/LocalStorageHelper';
import GlobalFunctionHelper from '../../Utilities/Helpers/GlobalFunctionHelper';
import AccessibilityHelper from '../../Utilities/Helpers/AccessibilityHelper';

import { RouteEnum } from '../../Utilities/Enums/RouteEnums';
import { AdminModules } from '../../Utilities/Enums/AdminModulesEnum';
import { ViewType } from '../../Utilities/Enums/ViewTypeEnum';
import { AuthenticationField } from '../../Utilities/Enums/ParametersEnum';

import RootLayout from './RootLayout';
import UnderDevelopmentPage from '../../CustomViews/Pages/ErrorPages/UnderDevelopmentPage';
//DASHBOARD
import Dashboard from '../Dashboard/Dashboard';

//AUTHENTICATION
import Login from '../Authentication/Login';
import SignUp from '../Authentication/SignUp';
import Logout from '../Authentication/Logout';
import ForgotPassword from '../Authentication/ForgotPassword';
import ResetPassword from '../Authentication/ResetPassword';
import OTP from '../Authentication/OTP';
import RecoverAccount from '../Authentication/RecoverAccount';

//ADMIN
import AdminUserControlList from '../AdminUserControl/AdminUserControlList';
import AdminUserDetails from '../AdminUserControl/AdminUserDetails';

//COMPANY 
import CompaniesList from '../Companies/CompaniesList';
import CompanyDetails from '../Companies/CompanyDetails';

//LICENSE
import LicensesList from '../Licenses/LicensesList';
import BuyLicensePackage from '../Licenses/BuyLicensePackage';
import BuyLicense from '../Licenses/BuyLicense';
import GenerateLicense from '../Licenses/GenerateLicense';
import LicenseDetails from '../Licenses/LicenseDetails';

//BILLING
import BillingList from '../Billings/BillingList';
import BillingDetails from '../Billings/BillingDetails';

//MAINTENANCE
import AccessibilitiesList from '../Maintenance/Accessibilities/AccessibilitiesList';
import AccessibilityDetails from '../Maintenance/Accessibilities/AccessibilityDetails';
import ModuleSettingList from '../Maintenance/ModuleSetting/ModuleSettingList';
import PriceSettings from '../Maintenance/PriceSettings/PriceSettings';
import VendorsList from '../Maintenance/Vendors/VendorsList';
import RegistrationCodesList from '../Maintenance/RegistrationCodes/RegistrationCodesList';

const AppRoutes = () => {
    //Variables
    const _userData: Authentication = LocalStorageHelper.getUserData();
    let queryString = window.location.search;
    let queryParams = new URLSearchParams(queryString);
    let vType = parseInt(queryParams.get('view') ?? ViewType.PREVIEW.toString());
    let isLoggedIn = true //LocalStorageHelper.isLoggedIn();
    let darkMode = LocalStorageHelper.isDarkMode();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    let rootLayoutContentPageProps = {
        isError: false,
    };
    const byPassLogIn = GlobalFunctionHelper.getBypassLogin();

    let contentPageProps = {
        // loadingState: loadingState,
        // isLoggedIn: isLoggedIn,
        // darkMode: darkMode,
        // errorOutlet: null,
    };
    
    let errorContentPageProps = {
        isError: true,
    };

    const router = createBrowserRouter([
        {
            path: RouteEnum.LOGIN,
            element: <Login {...contentPageProps} />,
        },
        {
            path: RouteEnum.SIGN_UP,
            element: <SignUp {...contentPageProps} />
        },
        {
            path: RouteEnum.LOGOUT,
            element: <Logout {...contentPageProps} />
        },
        {
            path: RouteEnum.FORGOT_PASSWORD,
            element: <ForgotPassword {...contentPageProps} />
        },
        {
            path: RouteEnum.RESET_PASSWORD,
            element: <ResetPassword {...contentPageProps} />
        },
        {
            path: RouteEnum.OTP,
            element: <OTP {...contentPageProps} />
        },
        {
            path: RouteEnum.RECOVER_ACCOUNT,
            element: <RecoverAccount {...contentPageProps} />
        },
        {
            path: '/',
            element: isLoggedIn || byPassLogIn ? <RootLayout {...rootLayoutContentPageProps} />
                : <Login {...contentPageProps} />,
            errorElement: <RootLayout {...errorContentPageProps} />,
            children: [

                //----------------MENU------------------
                //DASHBOARD
                {
                    path: RouteEnum.DASHBOARD,
                    element: <Dashboard {...contentPageProps} />,
                },
                //AUTHENTICATION

                //ADMIN
                {
                    path: RouteEnum.ADMIN_USER_CONTROL,
                    element: <AdminUserControlList {...contentPageProps} />,
                },
                {
                    path: RouteEnum.ADMIN_USER_DETAILS,
                    element: <AdminUserDetails {...contentPageProps} />,
                },
                //COMPANY 
                {
                    path: RouteEnum.COMPANIES,
                    element: <CompaniesList {...contentPageProps} />,
                },
                {
                    path: RouteEnum.COMPANY_DETAILS,
                    element: <CompanyDetails {...contentPageProps} />,
                },
                //LICENSE
                {
                    path: RouteEnum.LICENSES,
                    element: <LicensesList {...contentPageProps} />,
                },
                {
                    path: RouteEnum.BUY_LICENSE,
                    element: <BuyLicense {...contentPageProps} />,
                },
                // {
                //     path: RouteEnum.BUY_LICENSE_PACKAGE,
                //     element: <BuyLicensePackage {...contentPageProps} />
                //     element: <BuyLicensePackage {...contentPageProps} />,
                // },
                {
                    path: RouteEnum.GENERATE_LICENSE,
                    element: <GenerateLicense {...contentPageProps} />,
                },
                {
                    path: RouteEnum.LICENSE_DETAILS,
                    element: <LicenseDetails {...contentPageProps} />,
                },
                
                //BILLING
                {
                    path: RouteEnum.BILLINGS,
                    element: <BillingList {...contentPageProps} />,
                },
                {
                    path: RouteEnum.BILLING_DETAILS,
                    element: <BillingDetails {...contentPageProps} />,
                },

                //MAINTENANCE
                {
                    path: RouteEnum.ACCESSIBILITIES,
                    element: <AccessibilitiesList {...contentPageProps} />,
                },
                {
                    path: RouteEnum.ACCESSIBILITY_DETAILS,
                    element: <AccessibilityDetails {...contentPageProps} />,
                },
                {
                    path: RouteEnum.MODULE_SETTING,
                    element: <ModuleSettingList {...contentPageProps} />,
                },
                {
                    path: RouteEnum.PRICE_SETTING,
                    element: <PriceSettings {...contentPageProps} />,
                },
                {
                    path: RouteEnum.VENDORS,
                    element: <VendorsList {...contentPageProps} />,
                },
                // {
                //     path: RouteEnum.REGISTRATION_CODES,
                //     element: <RegistrationCodesList {...contentPageProps} />,
                // },

                //MY PROFILE
                {
                    path: RouteEnum.MY_PROFILE,
                    element: <AdminUserDetails {...contentPageProps} />,
                },
            ],
        },
    ]);


    return <RouterProvider router={router} />;

}

export default AppRoutes;
